module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_m_albino.51f786ba.png";